/** Splits a decimal price into its whole and two-digit fractional parts, via integer cents to avoid float drift. */
export function priceParts(value: number): {whole: number; decimals: string} {
    const cents = Math.round(value * 100);
    return {
        whole: Math.floor(cents / 100),
        decimals: String(cents % 100).padStart(2, '0'),
    };
}

/** Formats a decimal price as an inline Belgian-format string, e.g. "9,99". */
export function formatPrice(value: number): string {
    const {whole, decimals} = priceParts(value);
    return `${whole},${decimals}`;
}

/** The unit behind a price, from the plan's duration: a year, a month, the number of days, or a card when there is none. */
export function priceUnit(durationDays: number | undefined): {key: string; params: {days: number}} {
    const key = durationDays == null ? 'priceUnit.card'
        : durationDays === 365 ? 'priceUnit.year'
        : durationDays === 30 ? 'priceUnit.month'
        : 'priceUnit.days';
    return {key, params: {days: durationDays ?? 0}};
}
